import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, postData, updateData } from '../../../../apiService';
import { useAuth } from '../../../../AuthContext';
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

function BrandSection() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const history = useHistory();
    const { companyId, permissions, userId, token, logout } = useAuth();
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");
    const [Name, setName] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [updatedData, setUpdateData] = useState({});

    useEffect(() => {
        fetchtableData();
    }, [companyId, token]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('BrandApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Brand Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDelete = async () => {
        deleteData('BrandApi', `${deleteItemId}`, token)
            .then(() => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
        setErrorMessage('');
        setName('');
    };

    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Brand Name already exists!");
            setIsLoading(false);
            return;
        }

        const Brand = {
            CompanyId: companyId,
            Name,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('BrandApi', Brand, token)
            .then(() => {
                setName("");
                setIsModalGrpOpen(false);
                fetchtableData();
            })
            .catch((error) => {
                console.error('Brand Create error:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const openDetailModal = async (Id) => {
        try {
            const response = await fetchData('BrandApi', `/MasterDetails/${Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Brand Details:', error);
        }
    };

    const toggleModalGrp2 = () => {
        setIsDetailModalOpen(false);
        setErrorMessageEdit('');
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true);

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }

        try {
            const dataToUpdate = { ...updatedData };
            await updateData('BrandApi', `${updatedData.Id}`, dataToUpdate, token);
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false);
        }
    };

    return (
        <div>
            {/* Modern Header Bar */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                padding: '8px 12px',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
            }}>
                <h6 style={{
                    margin: 0,
                    fontSize: '14px',
                    fontWeight: '700',
                    color: '#2d3748',
                    letterSpacing: '-0.3px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span style={{ fontSize: '14px' }}>🏷️</span>
                    BRANDS
                </h6>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ position: 'relative' }}>
                        <input
                            type="text"
                            placeholder="Search brands..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '280px' : '220px',
                                height: '32px',
                                border: '2px solid',
                                borderColor: isFocused ? '#667eea' : '#e2e8f0',
                                borderRadius: '12px',
                                padding: '0 16px 0 40px',
                                fontSize: '14px',
                                transition: 'all 0.3s ease',
                                outline: 'none',
                                background: 'white',
                                boxShadow: isFocused ? '0 4px 12px rgba(102, 126, 234, 0.15)' : 'none',
                            }}
                        />

                    </div>

                    <Tooltip title="Add New Brand" arrow placement="top">
                        <Button
                            onClick={toggleModalGroup}
                            style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                fontWeight: '600',
                                height: '32px',
                                padding: '0 24px',
                                fontSize: '13px',
                                textTransform: 'none',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                transition: 'all 0.3s ease',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                            }}
                        >
                            + New Brand
                        </Button>
                    </Tooltip>
                </div>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% {
                                    box-shadow: .2em 0px 0 0px currentcolor;
                                }
                                12% {
                                    box-shadow: .2em .2em 0 0 currentcolor;
                                }
                                25% {
                                    box-shadow: 0 .2em 0 0px currentcolor;
                                }
                                37% {
                                    box-shadow: -.2em .2em 0 0 currentcolor;
                                }
                                50% {
                                    box-shadow: -.2em 0 0 0 currentcolor;
                                }
                                62% {
                                    box-shadow: -.2em -.2em 0 0 currentcolor;
                                }
                                75% {
                                    box-shadow: 0px -.2em 0 0 currentcolor;
                                }
                                87% {
                                    box-shadow: .2em -.2em 0 0 currentcolor;
                                }
                            }
                        `}</style>
                    <div className="loader"></div>
                    <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                        Loading...
                    </span>
                </div>
            )}

            {/* Create Modal */}
            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div className="bg-white w-full overflow-hidden" style={{ maxWidth: '900px', maxHeight: '70vh', borderRadius: '16px', boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)' }}>
                        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', height: '55px', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h6 style={{ color: 'white', fontSize: '15px', fontWeight: '700', margin: 0 }}>New Brand</h6>
                                <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '13px', margin: '2px 0 0 0' }}>Add a new Brand to your system</p>
                            </div>
                            <button onClick={toggleModalGroup} style={{ background: 'rgba(255, 255, 255, 0.2)', border: 'none', borderRadius: '50%', width: '36px', height: '36px', cursor: 'pointer', color: 'white', fontSize: '22px' }}>×</button>
                        </div>

                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 150px)', padding: '16px 20px' }}>
                            {errorMessage && (
                                <div style={{ background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)', border: '1px solid #fca5a5', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <span style={{ fontSize: '20px' }}>⚠️</span>
                                    <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessage}</p>
                                </div>
                            )}

                            <form onSubmit={addGroupRecord}>
                                <div>
                                    <label style={{ display: 'block', color: '#374151', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>
                                        Name <span style={{ color: '#ef4444' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={Name}
                                        onChange={(e) => setName(e.target.value)}
                                        style={{ width: '100%', padding: '7px 10px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', outline: 'none', height: '32px' }}
                                        placeholder="Enter Brand name"
                                    />
                                </div>
                            </form>
                        </div>

                        <div style={{ background: 'linear-gradient(to right, #f9fafb, #f3f4f6)', padding: '16px 24px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button onClick={toggleModalGroup} disabled={isLoading} style={{ padding: '8px 24px', background: 'white', border: '2px solid #e5e7eb', borderRadius: '10px', fontSize: '13px', fontWeight: '600', color: '#6b7280', cursor: isLoading ? 'not-allowed' : 'pointer' }}>Cancel</button>
                            <button onClick={addGroupRecord} disabled={isLoading} style={{ padding: '8px 24px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '600', color: 'white', cursor: isLoading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {isLoading ? <><CircularProgress size={18} color="inherit" /><span>Saving...</span></> : <><span>✓</span><span>Add Brand</span></>}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modern Table */}
            <div style={{
                maxHeight: '520px',
                overflowY: 'auto',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                marginTop: '-15px'
            }}>
                <TableContainer component={Paper} sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderBottom: '2px solid #1e40af',
                                    color: 'white',
                                    fontWeight: '700',
                                    fontSize: '11px',
                                    padding: '2px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    border: '1px solid #ccc'
                                }}>
                                    #
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderBottom: '2px solid #1e40af',
                                    color: 'white',
                                    fontWeight: '700',
                                    fontSize: '11px',
                                    padding: '2px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    border: '1px solid #ccc'
                                }}>
                                    Brand Name
                                </TableCell>
                                <TableCell style={{
                                    //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderBottom: '2px solid #1e40af',
                                    color: 'white',
                                    fontWeight: '700',
                                    fontSize: '11px',
                                    padding: '2px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    textAlign: 'center',
                                    border: '1px solid #ccc'
                                }}>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.Id}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: 'rgba(102, 126, 234, 0.05)',
                                            transform: 'scale(1.001)',
                                            transition: 'all 0.2s ease'
                                        },
                                        borderBottom: '1px solid #f0f0f0'
                                    }}
                                >
                                    <TableCell sx={{
                                        padding: '3px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#667eea',
                                        width: '2%'
                                    }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '3px',
                                        fontSize: '12px',
                                        color: '#2d3748',
                                        fontWeight: '500',
                                        width: '90%'
                                    }}>
                                        {item.Name}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'center' }}>
                                        {hasEditMasterPermission && (
                                            <Tooltip title="Edit Brand" arrow>
                                                <IconButton
                                                    onClick={() => openDetailModal(item.Id)}
                                                    sx={{
                                                        background: 'rgba(102, 126, 234, 0.1)',
                                                        marginRight: '8px',
                                                        '&:hover': {
                                                            background: 'rgba(102, 126, 234, 0.2)',
                                                            transform: 'scale(1.1)'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <EditIcon style={{ color: '#110441ff', fontSize: '17px' }} />
                                                </IconButton>

                                            </Tooltip>
                                        )}
                                        {hasDeleteMasterPermission && (
                                            <Tooltip title="Delete Brand" arrow>
                                                <IconButton
                                                    onClick={() => openConfirmDialog(item.Id)}
                                                    sx={{
                                                        background: 'rgba(239, 68, 68, 0.1)',
                                                        '&:hover': {
                                                            background: 'rgba(239, 68, 68, 0.2)',
                                                            transform: 'scale(1.1)'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} />
                                                </IconButton>

                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Edit Modal */}
            {
                isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                        <div className="bg-white w-full overflow-hidden" style={{ maxWidth: '900px', maxHeight: '70vh', borderRadius: '16px', boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)' }}>
                            <div style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', height: '55px', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <h6 style={{ color: 'white', fontSize: '15px', fontWeight: '700', margin: 0 }}>Edit Brand</h6>
                                    <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '13px', margin: '2px 0 0 0' }}>Update Brand information</p>
                                </div>
                                <button onClick={toggleModalGrp2} style={{ background: 'rgba(255, 255, 255, 0.2)', border: 'none', borderRadius: '50%', width: '36px', height: '36px', cursor: 'pointer', color: 'white', fontSize: '22px' }}>×</button>
                            </div>

                            <div className="overflow-y-auto" style={{ maxHeight: 'calc(75vh - 150px)', padding: '16px 20px' }}>
                                {errorMessageEdit && (
                                    <div style={{ background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)', border: '1px solid #fca5a5', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <span style={{ fontSize: '20px' }}>⚠️</span>
                                        <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessageEdit}</p>
                                    </div>
                                )}

                                <form onSubmit={updateRecord}>
                                    <div>
                                        <label style={{ display: 'block', color: '#374151', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>
                                            Name <span style={{ color: '#ef4444' }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="Name"
                                            value={updatedData.Name || ''}
                                            onChange={handleUpdateInputChange}
                                            style={{ width: '100%', padding: '7px 10px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', outline: 'none', height: '32px' }}
                                            placeholder="Enter Brand name"
                                        />
                                    </div>
                                </form>
                            </div>

                            <div style={{ background: 'linear-gradient(to right, #f9fafb, #f3f4f6)', padding: '16px 24px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                <button onClick={toggleModalGrp2} disabled={isUpdateLoading} style={{ padding: '8px 24px', background: 'white', border: '2px solid #e5e7eb', borderRadius: '10px', fontSize: '13px', fontWeight: '600', color: '#6b7280', cursor: isUpdateLoading ? 'not-allowed' : 'pointer' }}>Cancel</button>
                                <button onClick={updateRecord} disabled={isUpdateLoading} style={{ padding: '8px 24px', background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '600', color: 'white', cursor: isUpdateLoading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {isUpdateLoading ? <><CircularProgress size={18} color="inherit" /><span>Updating...</span></> : <><span>✓</span><span>Update Brand</span></>}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* Delete Dialog */}
            <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog}>
                <DialogTitle>Delete Record?</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to delete this record?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">Cancel</button>
                    <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">Confirm</button>
                </DialogActions>
            </Dialog>
        </div >
    );
}

export default BrandSection;
